import { User } from "../../models/User";
import {
    RECEIVE_QUOTESREQ_APPROVAL_LIST,
    RECEIVE_ORDERSREQ_APPROVAL_LIST,
    RECEIVE_DASHBOARD_ARTWORK_LIST,
    FETCH_ERROR,
    IS_LOADING,
    RECEIVE_DASHBOARD_PASTDUEORDER_COUNT,
    RECEIVE_BILLED_ORDERS_COUNT,
    RECEIVE_CATALOGUE_COUNT
} from "../actions/dashboardActions";
import { RECEIVE_CURRENT_USER } from "../actions/sessionActions";
import { QuotesState } from "../state/dashboardState";
export const initState = {
    quoteListReqApproval: null,
    artworkListReqApproval: null,
    filters: {
        accountName: "",
        account_id: "",
        contact_id: "",
        source: "cp",
        cp_user_id: "",
    }
}

const DashboardReducer = (state: QuotesState = initState, action) => {
    switch (action.type) {
        case RECEIVE_CURRENT_USER: {
            const currentUser: User = action.currentUser;
            if (currentUser.portalPermissions && currentUser.portalPermissions.Order[0].allowedOtherContacts) {
                return {
                    ...state,
                    statuses: currentUser.portalPermissions && currentUser.portalPermissions.Order[0].allowedStatus,
                    filters: {
                        ...state.filters,
                        cp_user_id: action.currentUser.contactId,
                        account_id: action.currentUser.accountId,
                        contact_id: !action.currentUser.portalPermissions.Order[0].allowedOtherContacts ? action.currentUser.contactId : '',
                        orderStatus: currentUser.portalPermissions && currentUser.portalPermissions.Order[0].allowedStatus,
                    },
                };
            } else {
                return {
                    ...state,
                    statuses: currentUser.portalPermissions.Order[0].allowedStatus,
                    filters: {
                        ...state.filters,
                        cp_user_id: action.currentUser.contactId,
                        account_id: action.currentUser.accountId,
                        orderStatus: currentUser.portalPermissions.Order[0].allowedStatus,
                        contact_id: !action.currentUser.portalPermissions.Order[0].allowedOtherContacts ? action.currentUser.contactId : '',
                    },
                };
            }
        }
        case RECEIVE_QUOTESREQ_APPROVAL_LIST: {
            return {
                ...state,
                loading: false,
                quoteListReqApproval: action.payload,
            }
        }
        case RECEIVE_ORDERSREQ_APPROVAL_LIST: {
            return {
                ...state,
                loading: false,
                orderListReqApproval: action.payload,
            }
        }
        case RECEIVE_DASHBOARD_PASTDUEORDER_COUNT: {
            return {
                ...state,
                loading: false,
                pastDueordersCount: action.payload,
            }
        }
        case RECEIVE_CATALOGUE_COUNT: {
            return {
                ...state,
                loading: false,
                dashboardCatalogueCount: action.payload,
            }
        }
        case RECEIVE_BILLED_ORDERS_COUNT: {
            return {
                ...state,
                loading: false,
                dashboardBilledOrdersCount: action.payload,
            }
        }
        case RECEIVE_DASHBOARD_ARTWORK_LIST: {
            return {
                ...state,
                loading: false,
                artworkListReqApproval: Object.values(action.payload),
            }
        }
        case IS_LOADING: return {
            ...state,
            loading: action.loading
        }
        case FETCH_ERROR: {
            return {
                ...state,
                fetchError: true,
                loading: false
            }
        }
        default:
            return state;
    }
}

export default DashboardReducer;